import { Component } from '@angular/core';

@Component({
    selector: 'app-inclusaodedependentes',
    templateUrl: './inclusaodedependentes.component.html',
    styleUrls: ['./inclusaodedependentes.component.scss']
  })
  export class inclusaodedependentesComponent {}

